import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=50971c65&scoped=true&"
import script from "./Media.vue?vue&type=script&lang=js&"
export * from "./Media.vue?vue&type=script&lang=js&"
import style1 from "./Media.vue?vue&type=style&index=1&id=50971c65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50971c65",
  null
  
)

export default component.exports